var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'等级设置',path:'/shop/plugin/decorate-level/list'},
    {title:'用户管理',path:'/shop/plugin/decorate-level/manage'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }